import { Modal } from '@spo/storybook';
import { VpButton } from '@vtmn-play/react/headless';
import { useTranslation } from 'react-i18next';

type CancelModalProps = {
  isOpenModal: boolean;
  onClose: () => void;
  onClick: () => void;
};

export const CancelModal = ({
  isOpenModal,
  onClose,
  onClick,
}: CancelModalProps) => {
  const { t } = useTranslation();

  const footerModal = (
    <>
      <VpButton
        data-testid="cancel-modal_cancel-button"
        variant="secondary"
        shape="squared"
        size="medium"
        onClick={onClick}
      >
        {t('architecture.modal-cancel.cancel')}
      </VpButton>
      <VpButton
        data-testid="cancel-modal_action-button"
        variant="primary"
        shape="squared"
        size="medium"
        onClick={onClose}
      >
        {t('architecture.modal-cancel.validation')}
      </VpButton>
    </>
  );

  return (
    <Modal
      dataTestid="cancel-modal-container"
      footer={footerModal}
      isOpen={isOpenModal}
      title={t('architecture.modal-cancel.title')}
      ariaLabel="Cancel Modal"
      onClose={onClose}
    >
      <div className="cancel-modal-body">
        <div className="cancel-modal-subtitle">
          {t('architecture.modal-cancel.subtitle')}
        </div>
      </div>
    </Modal>
  );
};
